export const userName = (state) => state.user.username;
export const isLogin = (state) => state.isLogin;
export const regionWidthChangedNum = (state) => state.regionWidthChangedNum;
export const isMigratory = (state) => state.isMigratory;



// WEBPACK FOOTER //
// ./src/store/getters.js